module.exports = __webpack_public_path__ + "static/media/bg-vision.f2f12695.png";